/*
 * Temporary client-side white-background removal for product images.
 * Use until proper transparent PNGs are produced.
 *
 * Opt-out per image: add data-ww-transparent="skip"
 * Force-include any image: add data-ww-transparent="on"
 */
(function () {
  if (window.__wwTransparentBg) return;
  window.__wwTransparentBg = true;

  var WHITE_TOLERANCE = 14;
  var FEATHER = 6;
  var PROCESS_DELAY = 30;

  var selector = [
    'img[data-ww-transparent="on"]',
    '.card__media img',
    '.card-wrapper img',
    '.product__media img',
    '.product-media-container img',
    '.product-media img',
    '.media--transparent img',
    '.trending-products__image',
    '.trending-products__image-wrap img',
    '.pdp-products__image',
    '.pdp-products__image-wrap img'
  ].join(',');

  function isWhiteish(r, g, b) {
    return (
      r >= 255 - WHITE_TOLERANCE &&
      g >= 255 - WHITE_TOLERANCE &&
      b >= 255 - WHITE_TOLERANCE
    );
  }

  function processSrc(src) {
    return new Promise(function (resolve, reject) {
      fetch(src, { mode: 'cors', credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.blob();
        })
        .then(function (blob) {
          var objUrl = URL.createObjectURL(blob);
          var loader = new Image();
          loader.decoding = 'async';
          loader.onload = function () {
            try {
              var canvas = document.createElement('canvas');
              canvas.width = loader.naturalWidth;
              canvas.height = loader.naturalHeight;
              var ctx = canvas.getContext('2d');
              ctx.drawImage(loader, 0, 0);
              var data = ctx.getImageData(0, 0, canvas.width, canvas.height);
              var px = data.data;
              var feather = Math.max(0, FEATHER);
              var solidCut = WHITE_TOLERANCE - feather;
              for (var i = 0; i < px.length; i += 4) {
                var r = px[i];
                var g = px[i + 1];
                var b = px[i + 2];
                if (isWhiteish(r, g, b)) {
                  var minC = Math.min(r, g, b);
                  var dist = 255 - minC;
                  if (dist <= solidCut) {
                    px[i + 3] = 0;
                  } else if (feather > 0) {
                    var t = (dist - solidCut) / feather;
                    px[i + 3] = Math.round(t * 255);
                  }
                }
              }
              ctx.putImageData(data, 0, 0);
              canvas.toBlob(function (out) {
                URL.revokeObjectURL(objUrl);
                if (!out) return reject(new Error('toBlob failed'));
                resolve(URL.createObjectURL(out));
              }, 'image/png');
            } catch (err) {
              URL.revokeObjectURL(objUrl);
              reject(err);
            }
          };
          loader.onerror = function () {
            URL.revokeObjectURL(objUrl);
            reject(new Error('image load failed'));
          };
          loader.src = objUrl;
        })
        .catch(reject);
    });
  }

  function processImage(img) {
    if (!img || img.dataset.wwBgState) return;
    if (img.dataset.wwTransparent === 'skip') return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    if (/\.(svg|gif|webp)(\?|$)/i.test(src)) return;
    if (src.startsWith('data:') || src.startsWith('blob:')) return;
    img.dataset.wwBgState = 'pending';
    if (!img.dataset.wwOriginalSrc) img.dataset.wwOriginalSrc = src;
    processSrc(src)
      .then(function (newUrl) {
        img.removeAttribute('srcset');
        img.src = newUrl;
        img.dataset.wwBgState = 'done';
      })
      .catch(function () {
        img.dataset.wwBgState = 'skip';
      });
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                io.unobserve(entry.target);
                setTimeout(function () {
                  processImage(entry.target);
                }, PROCESS_DELAY);
              }
            });
          },
          { rootMargin: '200px' }
        )
      : null;

  function track(img) {
    if (!img || img.dataset.wwBgTracked) return;
    img.dataset.wwBgTracked = '1';
    if (img.complete && img.naturalWidth > 0) {
      io ? io.observe(img) : processImage(img);
    } else {
      img.addEventListener(
        'load',
        function () {
          io ? io.observe(img) : processImage(img);
        },
        { once: true }
      );
    }
  }

  function scan(root) {
    (root || document).querySelectorAll(selector).forEach(track);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes &&
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(selector)) track(n);
          if (n.querySelectorAll) scan(n);
        });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
